import { makeAutoObservable, runInAction, toJS } from 'mobx';

import { EResponseStatus } from '@enums';

import { ITopMenuStateOptions, IUiStoreParams } from './types';

export class UiStore {

	status: EResponseStatus = null;

	pageTitle = {
		value: '',
		isVisible: true,
		setTitle(value: string) {
			runInAction(() => {
				this.value = value;
			});
		},
		toggleVisibility(isVisible: boolean) {
			runInAction(() => {
				this.isVisible = isVisible;
			});
		},
	};

	topMenuBurgerButton = {
		isVisible: true,
		isBackMode: false,
		backUrl: '',

		toggleVisibility(isVisible: boolean) {
			runInAction(() => {
				this.isVisible = isVisible;
			});
		},
		toggleBackMode(backUrl: string | boolean) {
			runInAction(() => {
				this.backUrl = typeof backUrl === 'string'? backUrl : '';
				this.isBackMode = Boolean(backUrl);
			});
		},
	};

	slidingMenu = {
		isVisible: false,
		toggleVisibility(isVisible: boolean) {
			runInAction(() => {
				this.isVisible = isVisible;
			});
		},
	};

	topMenuIcons = {
		isVisible: false,
		toggleVisibility(isVisible: boolean) {
			runInAction(() => {
				this.isVisible = isVisible;
			});
		},
	};

	isOnline = true;

	isInstallButtonVisible = false;

	constructor() {
		makeAutoObservable(this);
	}

	toggleIsOnline(isOnline: boolean) {
		this.isOnline = isOnline;
	}

	toggleInstallButton(isVisible: boolean) {
		this.isInstallButtonVisible = isVisible;
	}

	toggleSlideMenu(shouldShow: boolean) {
		this.slidingMenu.toggleVisibility(shouldShow);
	}

	setStatus(status: EResponseStatus) {
		this.status = status;
	}

	resetStatus() {
		this.setStatus(null);
	}

	setTopMenuInitialState(options?: ITopMenuStateOptions) {
		this.setStatus(EResponseStatus.OK);

		// заголовок
		Boolean(options?.pageTitle) && this.pageTitle.setTitle(options?.pageTitle);
		// по умолчанию всегда показывем заголок
		this.pageTitle.toggleVisibility(options?.isShowPageTitle || true);

		// по умолчанию всегда показывем бургер
		this.topMenuBurgerButton.toggleVisibility(options?.isShowBurgerButton || true);

		// если у бургера указана ссылка назад, то он становится кнопкой назад
		this.topMenuBurgerButton.toggleBackMode(options?.backButtonUrl);

		// иконки
		this.topMenuIcons.toggleVisibility(!this.topMenuBurgerButton.isBackMode || options?.isShowIcons);
	}

	toJSON(): IUiStoreParams {
		return {
			pageTitle: this.pageTitle,
			topMenuBurgerButton: this.topMenuBurgerButton,
			slidingMenu: this.slidingMenu,
			isOnline: this.isOnline,
			topMenuIcons: this.topMenuIcons,
			isInstallButtonVisible: this.isInstallButtonVisible,
			status: this.status,
		};
	}

	fromJSON(data: IUiStoreParams) {
		this.status = data.status;
		this.isOnline = data.isOnline;
		this.pageTitle = { ...toJS(this.pageTitle), ...data.pageTitle };
		this.topMenuBurgerButton = { ...toJS(this.topMenuBurgerButton), ...data.topMenuBurgerButton };
		this.slidingMenu = { ...toJS(this.slidingMenu), ...data.slidingMenu };
		this.topMenuIcons = { ...toJS(this.topMenuIcons), ...data.topMenuIcons };
		this.isInstallButtonVisible = data.isInstallButtonVisible;
	}

}
